export default "__VITE_ASSET__39714e05__"